import { Controller } from '@hotwired/stimulus'
import { getComponent, Component } from '@symfony/ux-live-component'
import { mercureSubscribe, mercureUnsubscribe } from '@/service/mercure'
import ModalController from '@/public/components/Modal/controller'
import LotCompletionTimeController from '@/public/blocks/LotCompletionTime/controller'
import LotCardController from '@/public/blocks/LotCard/controller'

type LiveComponent = {
    on(event: string, callback: () => void): void
}

/* stimulusFetch: 'lazy' */
export default class extends Controller {
    static targets = ['slider']

    private swiper: any | null = null
    declare sliderTarget: HTMLElement

    async sliderTargetConnected(element: HTMLElement) {
        const [{ default: Swiper }, { Autoplay }] = await Promise.all([
            import('swiper'),
            import('swiper/modules')
        ])

        // @ts-ignore
        await import('swiper/swiper-bundle.css')

        this.swiper = new Swiper(element, {
            modules: [Autoplay],
            spaceBetween: 24,
            grabCursor: true,
            slidesPerView: 1,
            autoplay: {
                delay: 5000,
            }
        })
    }

    sliderTargetDisconnected(element: HTMLElement) {
        this.swiper?.destroy()
    }
}
